import Vue from "vue";
import createAuth0Client from "@auth0/auth0-spa-js";

const DEFAULT_REDIRECT_CALLBACK = () =>
  window.history.replaceState({}, document.title, window.location.pathname);

let instance;

export const getInstance = () => instance;

export const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}) => {
  if (instance) return instance;

  instance = new Vue({
    data() {
      return {
        loading: true,
        isAuthenticated: false,
        isSuperAdmin: false,
        isDocRegAdmin: false,
        user: {},
        auth0Client: null,
        popupOpen: false,
        error: null
      };
    },
    methods: {
      async loginWithPopup(o) {
        this.popupOpen = true;

        try {
          await this.auth0Client.loginWithPopup(o);
          this.user = await this.auth0Client.getUser();
          this.isAuthenticated = await this.auth0Client.isAuthenticated();
          var userRoles = (await this.auth0Client.getIdTokenClaims())["https://mahaka.fr/roles"];
          this.isSuperAdmin = userRoles.includes("SuperAdmin");
          this.isDocRegAdmin = userRoles.includes("DocRegAdmin");
          this.error = null;
        } catch (e) {
          this.error = e;
          // eslint-disable-next-line
          console.error(e);
        } finally {
          this.popupOpen = false;
        }        
        this.user = await this.auth0Client.getUser();//New
        this.isAuthenticated = true;//New
      },
      /** Handles the callback when logging in using a redirect */
      async handleRedirectCallback() {
        this.loading = true;
        try {
          await this.auth0Client.handleRedirectCallback();
          this.user = await this.auth0Client.getUser();
          this.isAuthenticated = true;

          var claims = await this.auth0Client.getIdTokenClaims();
          if (claims) {
            var userRoles = claims["https://mahaka.fr/roles"];
            this.isSuperAdmin = userRoles.includes("SuperAdmin");
            this.isDocRegAdmin = userRoles.includes("DocRegAdmin");
          }

          this.error = null;
        } catch (e) {
          this.error = e;
        } finally {
          this.loading = false;
        }
      },
      loginWithRedirect(o) {
        return this.auth0Client.loginWithRedirect(o);
      },
      getIdTokenClaims(o) {
        return this.auth0Client.getIdTokenClaims(o);
      },
      getTokenSilently(o) {
        return this.auth0Client.getTokenSilently(o);
      },
      getTokenWithPopup(o) {
        return this.auth0Client.getTokenWithPopup(o);
      },
      logout(o) {
        return this.auth0Client.logout(o);
      }
    },
    async created() {
      this.auth0Client = await createAuth0Client({
        /* domain: options.domain,
        client_id: options.clientId,
        audience: options.audience,
        redirect_uri: redirectUri */
        //New
        ...options,
        client_id: options.clientId,
        redirect_uri: redirectUri,
        cacheLocation: 'localstorage',
        useRefreshTokens: true
      });

      try {
        if (
          window.location.search.includes("code=") &&
          window.location.search.includes("state=")
        ) {
          const { appState } = await this.auth0Client.handleRedirectCallback();
          this.error = null;
          // Notify subscribers that the redirect callback has happened, passing the appState
          onRedirectCallback(appState);
        }
      } catch (e) {
            console.log(e);
        this.error = e;
      } finally {
        this.isAuthenticated = await this.auth0Client.isAuthenticated();
        var claims = await this.auth0Client.getIdTokenClaims();
        if (claims) {
          var userRoles = claims["https://mahaka.fr/roles"];
          this.isSuperAdmin = userRoles.includes("SuperAdmin");
          this.isDocRegAdmin = userRoles.includes("DocRegAdmin");
        }
        this.user = await this.auth0Client.getUser();
        this.loading = false;
      }
    }
  });

  return instance;
};

export const Auth0Plugin = {
  install(Vue, options) {
    Vue.prototype.$auth = useAuth0(options);
  }
};
